import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgFeedbackWarning(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 121"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M51.712 36.81 21.994 84.794c-4.13 6.67.793 15.184 8.78 15.184h59.451c7.99 0 12.913-8.516 8.78-15.186L69.272 36.808c-3.992-6.441-13.57-6.44-17.56.002Z"
        fill="#FC0"
      />
      <path
        d="M64.5 84.978a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM63.438 72.334l1.057-20.39c.112-2.159-1.709-3.966-3.995-3.966s-4.107 1.807-3.995 3.965l1.057 20.39c.077 1.481 1.37 2.645 2.938 2.645s2.86-1.164 2.938-2.644Z"
        fill="#0F172A"
      />
      <path
        d="M34.894 41.336c1.364 1.618 3.476 2.457 5.064 2.193l-2.307-3.477 1.194-1.35c.196-.22.215-.575.024-.802-1.364-1.618-3.476-2.457-5.064-2.194l2.307 3.477-1.194 1.35c-.196.221-.215.576-.024.803Z"
        fill="#78B441"
      />
      <path
        d="M23.858 62c-1.669.93-2.936 2.644-3.348 4.254-.07.277.235.485.516.37l2.904-1.193a.417.417 0 0 1 .518.166l.745 1.32c.15.267.474.378.739.23 1.668-.93 2.936-2.644 3.347-4.254.07-.276-.235-.485-.516-.369l-2.904 1.192a.417.417 0 0 1-.518-.166l-.744-1.32c-.15-.267-.475-.378-.74-.23ZM94.946 58.425c-1.691.366-3.31 1.574-4.274 2.992a.536.536 0 0 0 .475.847l2.477-.193c.304-.024.572.214.612.542l.176 1.449c.04.333.29.564.577.501 1.691-.366 3.31-1.574 4.274-2.992a.536.536 0 0 0-.475-.847l-2.478.193c-.303.024-.571-.214-.611-.542l-.176-1.449c-.04-.333-.29-.564-.577-.501ZM57.715 21.04c-.395 1.595-.223 3.4.328 4.704.147.349.568.297.697-.061l.853-2.374c.084-.234.315-.36.533-.29l1.016.323c.229.073.47-.07.537-.34.395-1.595.224-3.4-.327-4.704-.148-.35-.569-.297-.697.06l-.853 2.374c-.085.235-.315.36-.533.291l-1.016-.323c-.23-.073-.47.07-.538.34Z"
        fill="#FC0"
      />
      <path
        d="M83.419 39.132c-1.224.804-2.18 2.116-2.606 3.38-.145.43.277.758.668.561l1.859-.937a.54.54 0 0 1 .712.22l.513.88c.127.217.397.29.615.147 1.223-.804 2.179-2.116 2.606-3.38.145-.43-.278-.758-.669-.561l-1.858.937a.54.54 0 0 1-.713-.22l-.513-.88a.427.427 0 0 0-.614-.147Z"
        fill="#78B441"
      />
    </svg>
  )
}
export default wrapIllustration(SvgFeedbackWarning)
